import request from '@utils/request';

// 获取短信验证码
export const getSmsCode = params =>
  request.post('/market/growth/channelpullnew/getsmscode', params);

// 登录
export const login = params => request.post('/market/growth/channelpullnew/login', params);

// 免登录
export const init = params => request.post('/market/growth/channelpullnew/init', params);

// 获取渠道
export const getchannel = params =>
  request.post('/market/growth/channelpullnew/getchannel', params);
